import { getData, putData } from 'src/api/http.service';
import { handleApiError, handleApiSuccess } from 'src/utils/general.utils';
import { ApiCallFailedAction, ApiCallInProgress, ApiCallSuccessAction } from './uistate.action';

export const DeliveryActionTypes = {
  GET_CURRENT_TABLE_INFO: '[API] : Get current table info',
  UPDATE_ADDRESS_DATA: '[API] : Update address data',
  PROCESS_ORDER: '[API] : Process the order',
  CANCEL_ORDER: '[API] : Cancel the order',
  UPDATE_ORDER_DATA: '[API] : Update order data',
  GET_ALL_CATALOGUES_DELIVERY_DATA: '[API] : Get all catalogues data',
};

/*
  Plain Actions
*/

export function GetCurrentTableInfoSuccessAction(payload) {
  return {
    type: DeliveryActionTypes.GET_CURRENT_TABLE_INFO,
    payload,
  };
}

export function UpdateAddressSuccessAction(payload) {
  return {
    type: DeliveryActionTypes.UPDATE_ADDRESS_DATA,
    payload,
  };
}

export function ProcessOrderSuccessAction(payload) {
  return {
    type: DeliveryActionTypes.PROCESS_ORDER,
    payload,
  };
}

export function CancelOrderSuccessAction(payload) {
  return {
    type: DeliveryActionTypes.PROCESS_ORDER,
    payload,
  };
}

export function UpdateOrderSuccessAction(payload) {
  return {
    type: DeliveryActionTypes.UPDATE_ORDER_DATA,
    payload,
  };
}

export function GetAllCataloguesDeliverySuccessAction(payload) {
  return {
    type: DeliveryActionTypes.GET_ALL_CATALOGUES_DELIVERY_DATA,
    payload,
  };
}

/*
  Async Actions
*/

export function GetCurrentTableInfoAction(url, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await getData(url, headers);
      dispatch(GetCurrentTableInfoSuccessAction(response.data));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return {
        status: true,
        data: response.data,
      };
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return {
        status: false,
      };
    }
  };
}

export function GetSelectedItemDetailsAction(url, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await getData(url, headers);
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return {
        status: true,
        data: response.data,
      };
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return {
        status: false,
      };
    }
  };
}

export function UpdateAddressAction(url, payload, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await putData(url, payload, headers);

      response.data.message = 'The address changes have been saved successfully!';
      dispatch(UpdateAddressSuccessAction(response.data));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export function ProcessOrderAction(url, payload, message, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await putData(url, payload, headers);
      dispatch(ProcessOrderSuccessAction(response.data));
      if (message) {
        response.data.message = message;
      }
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export function CancelOrderAction(url, payload, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await putData(url, payload, headers);
      dispatch(CancelOrderSuccessAction(response.data));
      response.data.message = 'The Order has been cancelled successfully!';
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export function UpdateOrderAction(url, payload, message, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await putData(url, payload, headers);
      dispatch(UpdateOrderSuccessAction(response.data));
      if (message) {
        response.data.message = message;
      }
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return {
        status: true,
        response: response.data,
      };
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return {
        status: false,
      };
    }
  };
}

export function GetAllCataloguesDeliveryAction(url, payload, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await getData(url, payload, headers);
      dispatch(GetAllCataloguesDeliverySuccessAction(response.data));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}
